import { Select } from '@ui';
import { useEffect, useRef, useState } from 'react';
import { bugApi, type Epic } from '../bugApi';

// Фл1: one list of the project's epics beside the search; a chosen epic leaves only the reports that belong to it.

/** The ids of the reports an epic holds («входит»); null — «Все эпики». */
export type EpicIds = ReadonlySet<number> | null;

/** Фл1: a report is shown when no epic is chosen or the epic holds it. */
export const inEpic = (reportId: number, ids: EpicIds): boolean => ids === null || ids.has(reportId);

export default function EpicFilter({ onChange, onError }: { onChange: (ids: EpicIds) => void; onError: (err: unknown, fallback: string) => void }) {
  const [epics, setEpics] = useState<Epic[]>([]);
  const [chosen, setChosen] = useState('');
  const fail = useRef(onError);
  fail.current = onError;

  useEffect(() => {
    bugApi
      .epics()
      .then((res) => setEpics(res.epics))
      .catch((err) => fail.current(err, 'Не удалось загрузить эпики'));
  }, []);

  const choose = async (value: string) => {
    setChosen(value);
    if (!value) return onChange(null);
    try {
      const detail = await bugApi.epic(Number(value));
      onChange(new Set(detail.links.filter((l) => l.kind === 'child').map((l) => l.reportId)));
    } catch (err) {
      setChosen('');
      onChange(null);
      fail.current(err, 'Не удалось загрузить эпик');
    }
  };

  return (
    <Select
      label="Эпик"
      hideLabel
      size="sm"
      value={chosen}
      onChange={(value) => void choose(value)}
      placeholder="Все эпики"
      options={[{ value: '', label: 'Все эпики' }, ...epics.map((e) => ({ value: String(e.id), label: `◆ ${e.id} ${e.title}` }))]}
      className="board-epic"
    />
  );
}
